import { render } from "./SchoolTestSelect.vue?vue&type=template&id=3322d5c3"
import script from "./SchoolTestSelect.vue?vue&type=script&lang=ts"
export * from "./SchoolTestSelect.vue?vue&type=script&lang=ts"
script.render = render
/* custom blocks */
import block0 from "./SchoolTestSelect.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(script)


export default script